var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 136 135",
    width: 136,
    height: 135,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#1ece68}.b{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m135.2 67.4c0-37.2-30.3-67.5-67.5-67.5-37.3 0-67.5 30.3-67.5 67.5 0 33.7 24.7 61.7 56.9 66.7v-47.1h-17.1v-19.6h17.1v-14.8c0-16.9 10.1-26.3 25.5-26.3 7.4 0 15.1 1.3 15.1 1.3v16.6h-8.5c-8.4 0-11 5.2-11 10.6v12.6h18.7l-3 19.6h-15.7v47.1c32.3-5 57-33 57-66.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m93.9 87l3-19.6h-18.7v-12.6c0-5.4 2.6-10.6 11-10.6h8.5v-16.6c0 0-7.7-1.3-15.1-1.3-15.4 0-25.5 9.4-25.5 26.3v14.8h-17.1v19.6h17.1v47.1q5.2 0.8 10.6 0.8 5.4 0 10.5-0.8v-47.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.32dd2b26ffe50336d481d5341af42e34.svg";
export { ForwardRef as ReactComponent };